import { normalize, mapObjectToList } from '../utils';

const initialState = {
  loading: false,
  errors: {},
  data: {},
};

const divisions = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'DIVISION_LIST_REQUEST':
      return {
        ...state,
        loading: true,
        data: {},
      };
    case 'DIVISION_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        data: Object.assign({}, state.data, normalize(payload)),
      };
    case 'DIVISION_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default divisions;

export const divisionsList = state => mapObjectToList(state.data);



// WEBPACK FOOTER //
// ./client/app/reducers/divisions.js